import React, { useEffect } from "react";

import { css } from "@emotion/react";
import { useNavigate } from "react-router-dom";
import { Common } from "@src/styles/Common";
import { useHomeCountData } from "@src/hooks/queries/useHomeCount";

const LectureBox = () => {
    const navigate = useNavigate();
    const { data, refetch } = useHomeCountData();

    const handleClick = () => {
        navigate("/offline/lectures");
    };

    useEffect(() => {
        refetch();
    }, []);

    return (
        <div css={expertStatBox} onClick={handleClick}>
            <div>
                <div css={userCountInfo} className="cursor" onClick={handleClick}>
                    <p
                        style={{
                            width: "100%",
                            fontWeight: "bold",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            marginBottom: "14px",
                        }}
                    >
                        <span>강의 신청 인원</span>
                        <span style={{ fontSize: "16px" }}>{" > "}</span>
                    </p>
                </div>

                {data?.lectureRegisterCount.map((item: any, idx: number) => (
                    <div css={userCountInfo} key={idx}>
                        <p>{item?.name}</p>
                        <p className="countText">{item?.count}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default LectureBox;

const expertStatBox = css`
    box-sizing: border-box;
    border: 1.5px solid ${Common.colors.gray200};
    border-radius: 8px;
    padding: 14px 20px;
    display: flex;
    flex-direction: column;
    gap: 6px;
`;

const userCountInfo = css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    ${Common.textStyle.title8_R12}
    color: ${Common.colors.gray700};
    text-align: center;
    line-height: 24px;

    .countText {
        text-align: right;
        width: 40px;
        font-size: 18px;
        font-weight: 700;
        color: ${Common.colors.black};
    }

    &.cursor {
        cursor: pointer;
    }
`;
